<!-- eslint-disable vue/no-v-html -->
<template>
  <div :data-cy="dataCy.modals.forms.deleteForm.form">
    <v-col
      v-if="unlinkedAnalysisRequests"
      offset="3"
      cols="6"
      class="text-center"
    >
      <span class="red--text">{{ analysisRequestMsg }}</span>
    </v-col>
    <v-col
      offset="3"
      cols="6"
      class="text-center"
    >
      {{ msg }}
    </v-col>
    <v-col
      class="text-left"
      v-html="security"
    />
    <v-col>
      <VTextarea
        v-model="data.security"
        :placeholder="$t('forms.labels.security')"
        solo
        height="40px"
        hideDetails
        :dataCy="dataCy.modals.forms.deleteForm.inputs.security"
        @input="updateData"
      />
    </v-col>
  </div>
</template>

<script>
import VTextarea from '@/components/shared/widgets/forms/VuetifyInputs/VTextarea.vue';
import { modals } from '@/aq-data-cy.json';

export default {
    components: {
        VTextarea,
    },
    props: {
        unlinkedAnalysisRequests: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            msg: '',
            security: '',
            analysisRequestMsg: '',
            data: {
                security: '',
            },
        };
    },
    computed: {
        dataCy() {
            return {
                modals,
            };
        },
    },
    mounted() {
        this.$emit('disabled', true);
    },
    created() {
        this.msg = this.$attrs.msg;
        this.security = this.$attrs.security;
        this.analysisRequestMsg = this.$attrs.analysisRequestMsg;
    },
    methods: {
        updateData(val) {
            this.$emit('security', val);
        },
    },
};
</script>
